export default __webpack_public_path__ + "static/educators-hero-5a0c9e1e415b7c6a439780e4a2f20085.jpeg";